module.exports = __webpack_public_path__ + "img/logo-axess.f2f8ad8f.png";